var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-wrapper",class:_vm.length <= 1 ? 'single' : ''},_vm._l((_vm.sliderItemList),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"dot",class:_vm.getDotClass(item)})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }